import { useState, useEffect } from "react";
import { AccountInfo, InteractionRequiredAuthError, InteractionStatus, IPublicClientApplication } from "@azure/msal-browser";
import { PersonnelService } from "../services/PersonnelService";
import { personnelRequest } from "../authConfig";

export const usePersonnelData = (
    inProgress: InteractionStatus,
    instance: IPublicClientApplication
) => {
    const [personnelData, setPersonnelData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const personnelService = new PersonnelService();

        const fetchPersonnelData = async () => {
            if (inProgress === InteractionStatus.None) {
                setIsLoading(true);
                try {
                    const data = await personnelService.getMe(instance);
                    setPersonnelData(data);
                } catch (error) {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect({
                            ...personnelRequest,
                            account: instance.getActiveAccount() as AccountInfo,
                        });
                    }
                    console.error("Error fetching personnel data:", error);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchPersonnelData();
    }, [inProgress, instance]);

    return { personnelData, isLoading };
};
